import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { investorApi } from "../../../api/api";
import CryptoJS from "crypto-js";
import ApartmentIcon from '@mui/icons-material/Apartment';
import TerrainIcon from '@mui/icons-material/Terrain';
import DomainIcon from '@mui/icons-material/Domain';
import { Link } from "react-router-dom";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
 
 
 
 
 
import {
  Box,
  Grid,
  Typography,
  IconButton,
  Stack,
  Select,
  MenuItem,
  useTheme,
  useMediaQuery,
  Modal,
  Fade,
  Backdrop,
  Chip,
  Button,
} from "@mui/material";
 
import {
  LocationOn as LocationOnIcon,
  WhatsApp as WhatsAppIcon,
  Instagram as InstagramIcon,
  ContentCopy as ContentCopyIcon,
  ShareOutlined as ShareOutlinedIcon,
  FavoriteBorder as FavoriteBorderIcon,
  Favorite as FavoriteIcon,
  CurrencyRupee as CurrencyRupeeIcon,
} from "@mui/icons-material";
 
import GradientButton from "../../common/GradiantButton";
import ShareProperty from "../../common/shareProperty";
import Loader from "../../common/Loader";
import SecondaryButton from "../../common/SecondaryButton";
import { toggleFavorite } from "../../../redux/reducers/favoritesSlice";
import ExploreIcon from "@mui/icons-material/Explore";
import LoginModal from "../../common/LoginModal";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ScreenContainer from "../../common/screencontainer";
 
 
 
 
export default function PropertyList({ searchQuery }) {
  const isAuthenticated = useSelector((state) => state.user.isAuthenticated);
  const [properties, setProperties] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState("All");
  const [loading, setLoading] = useState(true);
  const [showPopup, setShowPopup] = useState(false);
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [showAll, setShowAll] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 9;
 
 
  const [showLoginModal, setShowLoginModal] = useState(false);
 
 
  const themeColors = useSelector((state) => state.themeValue.colors);
  const themeMode = useSelector((state) => state.themeValue.theme);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user_refferal_code, userId } = useSelector((state) => state.user);
 
 
  const muiTheme = useTheme();
  const isMobile = useMediaQuery(muiTheme.breakpoints.down("sm"));

 const generateSlug = (property) => {
  const titlePart = `${property.name}-${property.city}`
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .trim();

  return `${titlePart}-${property.id}`;
}; 
 
const filterOptions = [
  { label: "All Properties", value: "All" },
  { label: "Plot/Land", value: "property" },
  { label: "Project Plots", value: "project" },
  { label: "Independent House/Villa", value: "villa" },
  { label: "Flat/Apartment", value: "apartment" },
];

 
  const favoriteItems = useSelector((state) => state.favorites.items);
 
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    const fetchProperties = async () => {
      try {
        const response = await investorApi.getPropertiesAndProjects();
      
        if (response.status === 200) setProperties(response.data);
      } catch (err) {
        console.error("API Fetch Error:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchProperties();
  }, [userId]);
 
 const formatIndianPrice = (price) => {
  if (!price) return "₹0";
 
  const num = Number(price);
 
  const format = (value) =>
    value.toFixed(2).replace(/\.00$/, "");
 
  if (num >= 10000000) return `${format(num / 10000000)} Cr`;
  if (num >= 100000) return `${format(num / 100000)} L`;
  if (num >= 1000) return `${format(num / 1000)} K`;
 
  return `₹${format(num)}`;
};
 
const getReferralQuery = (property) => {
  if (isAuthenticated && user_refferal_code) {
    return `${property.refferal_code}/${user_refferal_code}`;
  }
  return property.refferal_code;
};
 
//  const handleViewDetails = (property) => {
//   const referral = getReferralQuery(property);

//   const path =
//     property.type === "property"
//       ? `/PropertyDetailsScreen?${referral}`
//       : property.type === "project"
//       ? `/ProjectDetailsScreen?${referral}`
//       : property.type === "villa"
//       ? `/IndividualVillaScreen?${referral}`
//       : `/ApartmentPlotsScreen?${referral}`;

//   window.open(path, "_blank");
// };

const handleViewDetails = (property) => {
  const slug = generateSlug(property);

  let basePath = "";

  if (property.type === "property") {
    basePath = `/property/${slug}`;
  } else if (property.type === "project") {
    basePath = `/project/${slug}`;
  } else if (property.type === "villa") {
    basePath = `/villa/${slug}`;
  } else if (property.type === "apartment") {
    basePath = `/apartment/${slug}`;
  }

  if (isAuthenticated && user_refferal_code) {
    basePath += `?ref=${user_refferal_code}`;
  }

  window.open(basePath, "_blank");
};
 

 
 
  const filteredProperties = properties.filter((property) => {
    const city = property.city?.toLowerCase() || "";
    const address = property.address?.toLowerCase() || "";
    const name = property.name?.toLowerCase() || "";
    const query = (searchQuery || searchTerm).toLowerCase();
 
   const matchesType =
  selectedFilter === "All" || property.type === selectedFilter;

 
    const matchesSearch =
      city.includes(query) || address.includes(query) || name.includes(query);
 
    return matchesType && matchesSearch;
  });
 useEffect(() => {
  setCurrentPage(1);
}, [selectedFilter, searchQuery]);

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
 
  const visibleProperties = filteredProperties.slice(startIndex, endIndex);
 
 
 
 
  // const visibleProperties = filteredProperties;
 
 
  const toggleLike = (property) => {
    const uniqueId = `${property.type}_${property.id}`;
    dispatch(toggleFavorite(uniqueId));
  };
 
  const isLiked = (property) => {
    const uniqueId = `${property.type}_${property.id}`;
    return favoriteItems.includes(uniqueId);
  };
 
  // const getShareUrl = (property) => {
  //   const baseUrl = window.location.origin;
  //   const encodedReferral = encodeURIComponent(`${property.refferal_code}/${user_refferal_code}`);
  //   const path =
  //     property.type === "property"
  //       ? `PropertyDetailsScreen?${encodedReferral}`
  //       : property.type === "project"
  //         ? `ProjectDetailsScreen?${encodedReferral}`
  //         : property.type === "villa"
  //           ? `IndividualVillaScreen?${encodedReferral}`
  //           : property.type === "apartment"
  //             ? `ApartmentPlotsScreen?${encodedReferral}`
  //             : "";
 
  //   return `${baseUrl}/${path}`;
  // };

  const getShareUrl = (property) => {
  const baseUrl = window.location.origin;
  const slug = generateSlug(property);

  let path = "";

  if (property.type === "property") {
    path = `property/${slug}`;
  } else if (property.type === "project") {
    path = `project/${slug}`;
  } else if (property.type === "villa") {
    path = `villa/${slug}`;
  } else if (property.type === "apartment") {
    path = `apartment/${slug}`;
  }

  if (user_refferal_code) {
    path += `?ref=${user_refferal_code}`;
  }

  return `${baseUrl}/${path}`;
};
 
 
  const totalPages = Math.ceil(filteredProperties.length / itemsPerPage);
 
 
  return (
    <ScreenContainer>
    <Box sx={{  minHeight: "100vh", bgcolor: themeColors.screen_background ,padding:"10px"}}>
      {/* Header & Filter */}
      <Stack
        direction={{ xs: "column", sm: "row" }}
        justifyContent="end"
        alignItems="Start"
 
        mb={2}
        sx={{ paddingRight: 3 }}
      >
        {!isMobile && (
        <Select
  value={selectedFilter}
  onChange={(e) => setSelectedFilter(e.target.value)}
  size="small"
>
  {filterOptions.map((item) => (
    <MenuItem key={item.value} value={item.value}>
      {item.label}
    </MenuItem>
  ))}
</Select>
 
        )}
      </Stack>
 
      {/* Mobile Chips */}
     {isMobile && (
<Stack

    direction="row"

    flexWrap="wrap"

    gap={1}

    mb={3}
>

    {filterOptions.map((item) => {

      const isActive = selectedFilter === item.value;
 
      return (
<Button

          key={item.value}

          onClick={() => setSelectedFilter(item.value)}

          sx={{

            px: 2,

            py: 0.6,

            borderRadius: "20px",

            minWidth: "auto",

            textTransform: "none",

            fontSize: 12,

            fontWeight: 500,

            background: isActive

              ? `linear-gradient(90deg, ${themeColors.primary_gradient_start_color}, ${themeColors.primary_gradient_end_color})`

              : "#f2f2f2",

            color: isActive ? "#fff" : themeColors.text,

            boxShadow: isActive ? "0 3px 8px rgba(0,0,0,0.25)" : "none",

            transition: "all 0.2s ease",

            "&:active": {

              transform: "scale(0.96)",

            },

          }}
>

          {item.label}
</Button>

      );

    })}
</Stack>

)}

 
 
      {/* Loader */}
      {loading ? (
        <Loader />
      ) : (
        <Grid container sx={{
          // backgroundColor: "blue",
          flexDirection: "row",
          justifyContent: "start",
          gap: 2
        }}>
          {visibleProperties.map((property, index) => (
            <Grid item key={index}
              sx={{
                width: {
                  xs: "100%",   // extra-small screens (mobile)
                  sm: "45%",    // small screens (tablet)
                  md: "32%",    // medium screens (desktop)
                  lg: "32%",    // large screens
                },
                marginBottom: 3,
                // backgroundColor: "red"
              }}>
              <Box
                sx={{
                  borderRadius: 3,
                  overflow: "hidden",
                  boxShadow:
                    themeMode === "light"
                      ? "0 4px 16px rgba(0,0,0,0.2)"
                      : "0 4px 16px rgb(76,76,76)",
                  cursor: "pointer",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                  "&:hover": {
                    transform: "translateY(-6px)",
                    boxShadow: "0 8px 24px rgba(0,0,0,0.1)",
                  },
                }}
                onClick={() => handleViewDetails(property)}
              >
                {/* Image & Icons */}
                <Box
                  sx={{
                    height: 180,
                    backgroundImage: `url(${property.iconUrl ||
                      "https://via.placeholder.com/400x200.png?text=No+Image"})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    position: "relative",
                    //                 borderBottomLeftRadius: "12px",  
                    // borderBottomRightRadius: "12px",
                    // overflow: "hidden",    
                  }}
                >
                  <Stack direction="row" spacing={1} sx={{ position: "absolute", top: 8, right: 8 }}>
                    <IconButton
                      onClick={(e) => {
                        e.stopPropagation();
                        if (!isAuthenticated) {
                          setShowLoginModal(true);
                          return;
                        }
                        toggleLike(property);
                      }}
 
                      sx={{ bgcolor: "white" }}
                    >
                      {isLiked(property) ? <FavoriteIcon color="error" /> : <FavoriteBorderIcon />}
                    </IconButton>
 
                    <IconButton
                      onClick={(e) => {
                        e.stopPropagation();
                        if (!isAuthenticated) {
                          setShowLoginModal(true);
                          return;
                        }
                        setSelectedProperty(property);
                        setShowPopup(true);
                      }}
 
                      sx={{ bgcolor: "white" }}
                    >
                      <ShareOutlinedIcon />
                    </IconButton>
                  </Stack>
 
                  <Chip
                    label={property.type}
                    sx={{
                      position: "absolute",
                      bottom: 8,
                      right: 8,
                      bgcolor: "white",
                      fontWeight: "bold",
                      borderRadius: 5,
                      textTransform: "capitalize",
                    }}
                  />
                </Box>
 
                {/* Card Content */}
                <Box sx={{
                  p: 2,
                  minHeight: "13.5rem",
                  flexDirection: "column",
                  alignContent: "center",
                  borderTopRightRadius: "20px",
                  borderTopLeftRadius: '20px',
                  // overflow:"hidden"
                  // backgroundColor: "red",
 
 
                }}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      mb: 1,
 
                    }}
                  >
                    {/* Left: Property name */}
                    <Typography
                      variant="h6"
                      sx={{
                        color: themeColors.text,
                        display: '-webkit-box',
                        WebkitLineClamp: 2,        // number of lines to show
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',  // optional, shows "..." at the end
                        lineHeight: '1.2em',       // set proper line-height
                        maxHeight: '2.4em',        // 2 lines × 1.2em line-height
                      }}
                    >
                      {property.name}
                    </Typography>
 
 
                    {/* Right: Facing */}
 
 
                    {property.Facing && (
                      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                        <ExploreIcon
                          fontSize="small"
                          sx={{
                            transform: `rotate(${(() => {
                              const facing = property.Facing.toLowerCase();
 
                              if (facing.includes("north") && facing.includes("east")) return 45;
                              if (facing.includes("south") && facing.includes("east")) return 135;
                              if (facing.includes("south") && facing.includes("west")) return 225;
                              if (facing.includes("north") && facing.includes("west")) return 315;
 
                              if (facing.includes("north")) return 0;
                              if (facing.includes("east")) return 90;
                              if (facing.includes("south")) return 180;
                              if (facing.includes("west")) return 270;
 
                              return 0; // fallback
                            })()
                              }deg)`,
                            // color: themeColors.primary_gradient_start_color,
                          }}
                        />
                        <Typography
                          variant="body2"
                          sx={{ fontWeight: "bold", color: themeColors.text }}
                        >
                          {property.Facing}
                        </Typography>
                      </Box>
                    )}
 
                  </Box>
 
                  <Typography
                    variant="body2"
                    sx={{
                      display: "flex", alignItems: "center", gap: 0.5, mb: 1, display: '-webkit-box',
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: 'vertical',
                      overflow: 'hidden',
                    }}
                  >
                    <LocationOnIcon fontSize="small" />{property.address}, {property.city}
                  </Typography>
                  {property.type === "property" && (
                    <Typography
                      variant="body2"
                      sx={{ display: "flex", alignItems: "center", gap: 0.5, mb: 0.5, color: themeColors.primary_gradient_start_color,fontSize: 17, }}
                    >
                      <CurrencyRupeeIcon fontSize="small" />
                      {formatIndianPrice(property.latestSqFtPrice)} per sqft
 
                    </Typography>
                  )}
 
                  {property.type === "project" && (
                    <Typography
                      variant="body2"
                      sx={{ display: "flex", alignItems: "center", gap: 0.5, mb: 0.5, color: themeColors.primary_gradient_start_color }}
                    >
                      <DomainIcon fontSize="small" /> {property.Numberofplots} Plots | {property.AvailablePlots} Available
                    </Typography>
                  )}
 
                  {property.type === "villa" && (
                    <Typography
                      variant="body2"
                      sx={{ display: "flex", alignItems: "center", gap: 0.5, mb: 0.5, color: themeColors.primary_gradient_start_color,fontSize: 17, }}
                    >
                      <CurrencyRupeeIcon fontSize="small" />
                      {formatIndianPrice(property.latestMarketPrice)}
 
                    </Typography>
                  )}
 
                  {property.type === "apartment" && (
                      <Typography
                      variant="body2"
                      sx={{ display: "flex", alignItems: "center", gap: 0.5, mb: 0.5, color: themeColors.primary_gradient_start_color }}
                    >
                      <DomainIcon fontSize="small" /> {property.TotalUnits} Flats | {property.AvailableUnits} Available
                    </Typography>
                  )}
 
 
 
                  <SecondaryButton
                    text="View Details"
                    onClick={() => handleViewDetails(property)}
                    style={{ width: "100%" }}
                  />
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      )}
 
      {totalPages > 1 && (
 
 
<Box sx={{ display: "flex", justifyContent: "center", mt: 5 }}>
  <Pagination
    count={totalPages}
    page={currentPage}
    onChange={(e, value) => {
      setCurrentPage(value);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }}
    renderItem={(item) => (
      <PaginationItem
        {...item}
        components={{
          previous: () => <span>{"< Previous Page"}</span>,
          next: () => <span>{"Next Page >"}</span>,
        }}
        sx={{
          mx: 0.5,
          borderRadius: "50%",
          minWidth: 40,
          height: 40,
          fontWeight: 600,
 
          "&.Mui-selected": {
            backgroundColor: "#CBD5E1",   // active circle
            color: "#000",
          },
 
          "&:hover": {
            backgroundColor: "#E5E7EB",
          },
        }}
      />
    )}
    siblingCount={3}
    boundaryCount={1}
  />
</Box>
 
      )}
 
 
 
 
 
      {showLoginModal && (
        <LoginModal
          open={showLoginModal}
          onClose={() => setShowLoginModal(false)}
        />
      )}
 
 
 
      {/* Share Popup */}
      {showPopup && selectedProperty && (
        <ShareProperty
          property={selectedProperty}
          getShareUrl={getShareUrl}
          onClose={() => setShowPopup(false)}
        />
      )}
    </Box>
    </ScreenContainer>
  );
}